
import { AlertCircle, Shield, Lock } from "lucide-react";

export const ChallengesSection = () => {
  return (
    <section className="py-16 bg-white" id="challenges">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-edgefi-purple/10 text-edgefi-purple rounded-full text-sm font-medium mb-4">Your Security Struggles</span>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            When Security Uncertainty Keeps You Up at Night
          </h2>
          <p className="text-xl text-gray-600">
            You shouldn't have to choose between focusing on your business and protecting it from ever-evolving threats.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          <div className="bg-gradient-to-br from-edgefi-white to-white p-6 rounded-xl border border-edgefi-purple/10 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1">
            <div className="mb-5 w-12 h-12 rounded-full bg-edgefi-purple/10 flex items-center justify-center">
              <AlertCircle className="h-6 w-6 text-edgefi-purple" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Feeling Overwhelmed by Changing Rules</h3>
            <p className="text-gray-600">
              Every time you catch up with one set of regulations, three more appear. The constant pressure to stay compliant while running your business leaves you feeling stretched too thin.
            </p>
          </div>

          <div className="bg-gradient-to-br from-edgefi-white to-white p-6 rounded-xl border border-edgefi-purple/10 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1" style={{ transitionDelay: "0.1s" }}>
            <div className="mb-5 w-12 h-12 rounded-full bg-edgefi-purple/10 flex items-center justify-center">
              <Shield className="h-6 w-6 text-edgefi-purple" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Uncertainty About Your Protection</h3>
            <p className="text-gray-600">
              You've invested in security tools, but still wonder: "Is this enough? Are we truly protected?" This nagging doubt makes it hard to focus on growing your business with confidence.
            </p>
          </div>

          <div className="bg-gradient-to-br from-edgefi-white to-white p-6 rounded-xl border border-edgefi-purple/10 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1" style={{ transitionDelay: "0.2s" }}>
            <div className="mb-5 w-12 h-12 rounded-full bg-edgefi-purple/10 flex items-center justify-center">
              <Lock className="h-6 w-6 text-edgefi-purple" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Security vs. Business Growth</h3>
            <p className="text-gray-600">
              You feel caught between enabling innovation and maintaining security. Each new initiative seems to create friction with your security team, slowing down progress when you need to move quickly.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
